module.exports = __webpack_public_path__ + "static/img/staff.3df8b0c4.png";